import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "FlightsDark__IconWrapper",
  componentId: "sc-16hbcl9-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("path", {
    d: "M20.597 10.142l-14.436-4.5-1.885 1.884 12.04 6.899M24.05 13.595l4.498 14.44-1.884 1.885-6.896-12.039",
    stroke: themeGet("palette.background.darkest")(themeProps),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M11.91 25.074c-.075-.308.101-.574.331-.793 1.623-1.543 6.292-5.154 7.287-6.149L26.76 10.9a12.888 12.888 0 003.334-5.772.837.837 0 00-1.02-1.02 12.888 12.888 0 00-5.771 3.335l-7.233 7.233c-.994.994-4.695 5.883-6.149 7.286-.23.223-.484.406-.793.33l-4.243-1.03-.463.463 4.028 4.031 4.027 4.031.463-.463-1.03-4.242v-.008z",
    stroke: themeGet("palette.background.darkest")(themeProps),
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M17.85 6.792L15.91 4.85l-2.34 2.344 2.957.918 1.325-1.32zM26.888 16.955l1.942 1.942-2.344 2.343-.922-2.96 1.324-1.325z",
    fill: themeGet("palette.background.darkest")(themeProps),
    stroke: themeGet("palette.background.darkest")(themeProps),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const FlightsDark = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(FlightsDark);
export default Memo;